<template>
<Tooltip transfer :content="validMsg+''" theme="err" :disabled="!(validErr&&validErrMsgTip)"  class="ivu-table-cell-tooltip">
    <div  :class="getEditClass" @mouseenter="validErrMsgTipIn" @mouseleave="validErrMsgTipOut">
        <template>
            <div :class="[prefixCls + '-rel']" v-if="!always&&showContent">
                <template>
                    <Tooltip transfer :content="myContent" :disabled="!showTooltip" class="ivu-table-cell-tooltip">
                        <p ref="content" @mouseenter="handleTooltipIn" @mouseleave="handleTooltipOut" class="ivu-table-cell-tooltip-content">{{ myContent }}</p>
                    </Tooltip>
                </template>
            </div>
            <template>
                <div :class="[prefixCls + '-popper']"
                    v-if="visible||always"  >
                    <div :class="[prefixCls + '-content']+' table-edit-checkbox'"
                        :tabindex="selectTabindex"
                        v-on:blur.capture="handleBlur"
                        @focus.capture="handleFocus"
                        ref="checkbox">
                        <CheckboxGroup v-model="selectData" @on-change="change">
                            <Checkbox 
                                v-for="item in dataList" 
                                :label="item[editCfg.key]"
                                :code="item[editCfg.key]"
                                :key="item[editCfg.key]" 
                                :disabled="item.disabled"
                                v-if="!item.notVisible"
                                @on-blur="handleBlur" 
                                >{{item[editCfg.label]}}</Checkbox>
                        </CheckboxGroup>
                    </div>
                </div>
            </template>
        </template>
    </div>
</Tooltip>
</template>
<script>
import Tooltip from '../../tooltip/tooltip.vue';
const prefixCls = "table-edit";
export default {
  name: "plugCheckbox",
  components:{Tooltip},
  computed: {
    selectTabindex(){
        return this.disabled || this.filterable ? -1 : 0;
    },
    getEditClass() {
        return [
            `${this.prefixCls}`,
            {
                [`${this.prefixCls}-always`]: (this.editAlways||this.always)&&!this.visible,
                [`${this.prefixCls}-cell-valid-err`]: this.validErr === true&&!this.visible
            }
        ];
    }
  },
  props: {
    content: {
      type: [String, Number,Array]
    },
    row: [String, Number, Object],
    col: [String, Number, Object],
    editCfg: Object,
    dropIndex: Number,
    dropInit: Boolean,
    disabled: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: false
    },
    always: {
      type: Boolean,
      default: false
    },
    validErr:{
      type: Boolean,
      default: false
    },
    validMsg:String,
    maxWidth: {
      type: [String, Number]
    }
  },
  data() {
    return {
      prefixCls: prefixCls,
      selectData: [],
      myContent:"",
      showTooltip: false,
      showContent:true,
      isLeave:true,
      dataList:[],
      validErrMsgTip:false
    };
  },
  watch: {
        visible(newValue,oldValue){
            if(newValue){
                this.showContent=false
                this.$nextTick(function(){
                    this.$refs.checkbox.focus()
                })
            }else{
                this.showContent=true
            }
        },
        content(newValue,oldValue){
            this.selectData=newValue
            this.$emit("onChange", newValue, this.col,{},true);
        }
  },
  created(){
      this.dataList=this.editCfg.dataCfg.value
      this.editCfg.onAfterCreated&&this.editCfg.onAfterCreated(this,this.dataList)
  },
  methods: {
    initDataList(dataList){
        this.dataList=dataList
    },
    handleBlur(e) {   
        this.$emit("onChangeShowEdit", false,this.myContent);
    },
    handleFocus(e){
        this.$emit("onChangeShowEdit", true,this.myContent);
    },
    change(value) {
      this.myContent=this.getContent(value)
      this.$emit("onChange", value, this.col);
    },
    handleTooltipIn () {
      const $content = this.$refs.content;
      this.showTooltip = $content.scrollWidth > $content.offsetWidth;
    },
    handleTooltipOut () {
      this.showTooltip = false;
    },
    validErrMsgTipIn(){
      this.validErrMsgTip=true
    },
    validErrMsgTipOut(){
      this.validErrMsgTip=false
    },
    getContent(valueList,isFrist){
        let dataList=this.dataList,
        strs=[];
        for(let j=0;j<valueList.length;j++){
            for(let i=0;i<dataList.length;i++){
                let item=dataList[i]
                if(valueList[j]==item[this.editCfg.key]){
                    strs.push(item[this.editCfg.label])
                    if(isFrist){
                        this.selectData.push(valueList[j])
                    }
                    continue;
                }
            }
        }
        return strs.join()
    },
    setMyContent(){
        let valueList=[],cStr="";
        if(this.$utils.isArray(this.content)){
            valueList=this.content
        }else{
            valueList=this.content?this.content.split():[]
        }
        this.myContent=this.getContent(valueList,true)
    }
  },
  mounted() {
    this.setMyContent()
    this.editCfg.onAfterCompleted&&this.editCfg.onAfterCompleted(this,this.dataList)
  }
};
</script>




// WEBPACK FOOTER //
// src/components/common/table/plug/checkbox.vue